import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton, CircularProgress } from "material-ui"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import Table from "../../../components/common/Table"
import strings from "../../../localization/strings"
import Clear from "../../../components/misc/Clear"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import { IBadgeInfo, IBadge } from "../../../models"
import * as api from "../../../api"

interface IProps {
	handleClose(): void
	handleSave(Badges: IBadgeInfo[]): void
}
interface IState {
	BadgesList: IBadge[]
	selectedBadges: IBadgeInfo[]
	search: string
	loading: boolean
	total: number
	offset: number
	limit: number
}
const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
		cursor: "pointer"
	},
	otherCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 75
	}
}

export default class ChooseBadgeDialogForChip extends React.Component<IProps, IState> {
	private Badges: IBadge[]
	constructor(props) {
		super(props)
		this.Badges = []
		this.state = {
			BadgesList: [],
			selectedBadges: [],
			search: "",
			loading: false,
			total: 0,
			offset: 0,
			limit: 8,
		}
		autobind(this)
	}

	componentDidMount() {
		this.getBadgesList()
	}

	getBadgesList() {
		this.setState({ loading: true }, () => {
			api.getAccountHRISBadges(AccountStore.getCurrentAccount().Id)
			.then(res => {
				this.Badges = res.data.filter(badge => badge.Active) as IBadge[]
				this.setState({
					BadgesList: this.Badges.slice(0, this.state.limit),
					total: this.Badges.length,
					loading: false
				})
			})
			.catch(_err => {
				this.Badges = []
				this.setState({
					BadgesList: [],
					total: this.Badges.length,
					loading: false
				}, () => AppStateStore.setProgressSnackbarContent(strings.something_went_wrong))
			})
		})
	}
	
	// Updating the List for Client-Side Pagination & Searching
	updateBadgeList() {
		const filteredList = this.Badges.filter(item => !this.state.search || item.Name.toLowerCase().includes(this.state.search.toLowerCase())).filter((_v, index) => index >= this.state.offset && index < this.state.offset + this.state.limit)
		if (this.state.search !== "") this.setState({ BadgesList: filteredList, total: filteredList.length })
		else this.setState({ BadgesList: filteredList, total: this.Badges.length })
	}
	
	handleSelectBadges(selectedBadges) {
		selectedBadges = selectedBadges.slice().map(badge => (
			{
				Id: badge.Id,
				Name: badge.Name,
				BadgeStyle: badge.Style,
				BadgeColor: badge.Color
			}
		))
		this.setState({ selectedBadges })
	}

	BadgesTable = () => (
		!this.state.BadgesList.length ?
			<h2 style={{ textAlign: "center", marginTop: 25 }}>
			{strings.No_Badge_Found}
			</h2> :
		<Table
			items={this.state.BadgesList}
			handleSelect={this.handleSelectBadges}
			total={this.state.total}
			offset={this.state.offset}
			limit={this.state.limit}
			limitOptions={[8, 20, 50]}
			onPageClick={offset => this.setState({ offset }, () => this.updateBadgeList())}
			onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.updateBadgeList())}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody showRowHover deselectOnClickaway={false}>
				{this.state.BadgesList.map((item, index) =>
					<TableRow key={index} selected={this.state.selectedBadges.find(badge => badge.Id === item.Id) ? true : false}>
						<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
					</TableRow>
				)}
			</TableBody>
			
		</Table>
	)

	render() {
		return (
			<Dialog
				modal
				open
				title={strings.Choose_Badges}
				actions={[
					<FlatButton
						label={strings.Cancel}
						secondary
						onClick={this.props.handleClose}
					/>,
					<FlatButton
						label={strings.OK}
						primary
						keyboardFocused
						disabled={this.state.selectedBadges.length > 0 ? false : true}
						onClick={() => {
							this.props.handleSave(this.state.selectedBadges)
						}}
					/>
				]}
				onRequestClose={this.props.handleClose}
			>
				<div style={{ padding: 20, paddingLeft: 35 }}>
					<i style={{ fontSize: 25 }} className="fa fa-search" />
					<TextField
						hintText={strings.search}
						style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
						value={this.state.search}
						onChange={e => this.setState({ search: e.target.value, offset: 0 }, () => this.updateBadgeList())}
					/>
					<Clear />
				</div>
				<div style={{ textAlign: "center", height: "auto", minHeight: 520 }}>
					{this.state.loading ?
						<CircularProgress /> :
						<div>{this.BadgesTable()}</div>
					}
				</div>
			</Dialog>
		)
	}
}